import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiSearchApi, AiSearchApiImpl } from './apis';
import { DataCoverageApi, DataCoverageApiImpl } from './apis/dataCoverage';
import { EntityApi, EntityApiImpl } from './apis/entity';
import { SynapseChartApi, SynapseChartApiImpl } from './apis/synapse-chart';

export const aiSearchContainer = new ContainerModule((bind) => {
    bind<AiSearchApi>(AiSearchApi).to(AiSearchApiImpl);
    bind<DataCoverageApi>(DataCoverageApi).to(DataCoverageApiImpl);
    bind<EntityApi>(EntityApi).to(EntityApiImpl);
    bind<SynapseChartApi>(SynapseChartApi).to(SynapseChartApiImpl);
});

export { AiSearchApi } from './apis';
export { DataCoverageApi } from './apis/dataCoverage';
export { EntityApi } from './apis/entity';
export { SynapseChartApi } from './apis/synapse-chart';
